/**
 * @file        src/pages/Stub.jsx
 * @description Placeholder page used by every route that doesn't have a
 *              bespoke implementation yet. Keeps navigation honest end-to-end:
 *              users can click into every menu item and see the section render
 *              with proper chrome, even before the team builds the screen.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
import { useLocation } from 'react-router-dom';
import PageHead from '../components/PageHead';
import { flatPaths } from '../lib/nav';

export default function Stub() {
  const { pathname } = useLocation();
  const entry = flatPaths().find((p) => p.path === pathname);
  const label = entry?.label || 'Coming soon';
  const group = entry?.group;

  return (
    <>
      <PageHead title={label} subtitle={group || 'Section under construction'} />
      <article className="panel glass">
        <div className="empty">
          <h3>{label}</h3>
          <p className="muted">This screen isn't built yet. Wire the matching API endpoint and add a page component to ship it.</p>
        </div>
      </article>
    </>
  );
}
